module.exports = __webpack_public_path__ + "img/clock-blue.a2982f89.svg";